/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Modify_Clock_TimesInputs */



/**
* | output |
* | --- |
* | "Modify Clock Times" |
*
* @param {Modify_Clock_TimesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const modify_clock_times = /** @type {((inputs?: Modify_Clock_TimesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Modify_Clock_TimesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier les temps d’horloge")
	if (locale === "de") return /** @type {LocalizedString} */ ("Uhrzeiten ändern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica gli orari dell'orologio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменить время на часах")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modificar la hora del reloj")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修改时钟时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("時計の時間を変更する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घड़ी के समय में बदलाव करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterar horários do relógio")
	return /** @type {LocalizedString} */ ("Modify Clock Times")
});